import React, { useContext, useState } from 'react';
import { Agreement } from "../enums/Agreement";
import { useFormikContext } from "formik";
import { EmployeeFormValues } from "./EmployeeFormValues";
import { EmployerFormValues } from "./EmployerFormValues";
import { PhysicianFormValues } from "./PhysicianFormValues";
import { BeneficiaryFormValues } from "./BeneficiaryFormValues";
import { DisabilityEmployeeFormValues } from "../disability/DisabilityEmployeeFormValues";
import { AccidentEmployeeFormValues } from "../accident/AccidentEmployeeFormValues";
import { CriticalIllnessEmployeeFormValues } from "../illness/CriticalIllnessEmployeeFormValues";
import { HospitalIndemnityEmployeeFormValues } from "../indemnity/HospitalIndemnityEmployeeFormValues";
import { PfmlEmployeeFormValues } from "../pfml/PfmlEmployeeFormValues";
import Checkbox from "../input/Checkbox";
import { PdsButton } from "@principal/design-system-react";
import findAgreementsFor = Agreement.findAgreementsFor;
import findAgreementIdFor = Agreement.findAgreementIdFor;
import findModalFor = Agreement.findModalFor;
import FraudAboveSignature from "../structure/FraudAboveSignature";
import { StepContext } from "../navigation/FormikStepper";
import { EmployeePages } from "../enums/EmployeePages";

const Agreements = () => {
    const {
        initialValues,
        values
    } = useFormikContext<EmployeeFormValues | EmployerFormValues | PhysicianFormValues | BeneficiaryFormValues
        | DisabilityEmployeeFormValues | AccidentEmployeeFormValues | CriticalIllnessEmployeeFormValues
        | HospitalIndemnityEmployeeFormValues | PfmlEmployeeFormValues>();
    const [activeAgreement, setActiveAgreement] = useState<Agreement | null>(null)
    const agreements = findAgreementsFor(initialValues, values)
    const { steps, stepChangeCallback } = useContext(StepContext);

    const navigateToHipaaStep = () => {
        const hipaaStepIndex = steps.findIndex(step => step.props.label === EmployeePages.HIPAA);
        if (hipaaStepIndex !== -1) {
            stepChangeCallback(hipaaStepIndex);
        }
    };

    return (
        <div className="flex-gap">
            <div>To submit and process your claim, please click on the link below to review the form(s), then check the box to agree.</div>
            <div>{agreements.map((agreement) => {
                if (agreement === Agreement.HIPAA_AUTHORIZATION) {
                    return <React.Fragment key={agreement}>
                        <Checkbox id={findAgreementIdFor(agreement)}
                                  disabled={true}
                                  label={
                                      <PdsButton type="button" link="default" size="sm" onClick={navigateToHipaaStep}>
                                          {agreement}
                                      </PdsButton>
                                  }>
                        </Checkbox>
                    </React.Fragment>
                }
                const Modal = findModalFor(agreement)

                return <React.Fragment key={agreement}>
                    <Checkbox id={findAgreementIdFor(agreement)}
                              disabled={true}
                              label={
                                  <PdsButton type="button" link="default" size="sm" onClick={() => {
                                      setActiveAgreement(agreement)
                                  }}>
                                      {agreement}
                                  </PdsButton>
                              }>
                    </Checkbox>
                    <Modal inModal={agreement === activeAgreement} onClose={() => {
                        setActiveAgreement(null)
                    }}/>
                </React.Fragment>
            })}
            </div>
            <FraudAboveSignature/>
        </div>
    )
};

export default Agreements;
